import { useState, type FormEvent } from 'react';
import { useAuthStore } from '../features/auth/auth-store';

export default function Login() {
  const { signIn, error: authError, loading } = useAuthStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-primary px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-semibold text-zinc-100">Glossika Content</h1>
          <p className="text-sm text-zinc-500 mt-1">mazmun.glossika.com</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm text-zinc-400 mb-1">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@glossika.com"
              className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded text-zinc-100 placeholder:text-zinc-600 focus:outline-none focus:border-teal-500 text-sm"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm text-zinc-400 mb-1">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded text-zinc-100 focus:outline-none focus:border-teal-500 text-sm"
            />
          </div>

          {(error || authError) && (
            <p className="text-red-400 text-sm">{error || authError}</p>
          )}

          <button
            type="submit"
            disabled={submitting || loading}
            className="w-full py-2 bg-teal-600 hover:bg-teal-500 disabled:opacity-50 rounded text-white text-sm font-medium transition-colors"
          >
            {submitting ? 'Signing in...' : 'Sign in'}
          </button>

          <p className="text-xs text-zinc-600 text-center mt-3">
            Restricted to Glossika employees. Contact admin for access.
          </p>
        </form>
      </div>
    </div>
  );
}
